export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

export const validateForm = (form) => {
  const errors = {};

  if (!form.name || form.name.trim().length < 2) {
    errors.name = 'Name must be at least 2 characters';
  }

  if (!form.email || !validateEmail(form.email)) {
    errors.email = 'Please enter a valid email';
  }

  if (form.business_name && form.business_name.trim().length < 2) {
    errors.business_name = 'Business name must be at least 2 characters';
  }

  return { isValid: Object.keys(errors).length === 0, errors };
};
